var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.21875C12.14 2.21882 13.875 3.95369 13.875 6.09375V7.65625H16.25V17.0312H3.75V7.65625H6.125V6.09375C6.125 3.95365 7.8599 2.21875 10 2.21875ZM10 9.21875C9.24061 9.21875 8.625 9.83436 8.625 10.5938C8.625 11.1277 8.93032 11.5886 9.375 11.8164V13.9062C9.375 14.2514 9.65482 14.5312 10 14.5312C10.3451 14.5312 10.625 14.2514 10.625 13.9062V11.8164C11.0696 11.5886 11.375 11.1277 11.375 10.5938C11.375 9.8344 10.7593 9.21882 10 9.21875ZM10 3.71875C8.68832 3.71875 7.625 4.78207 7.625 6.09375V7.65625H12.375V6.09375C12.375 4.78211 11.3116 3.71882 10 3.71875Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.9ec6d3d82c27c580fe1739e7e3cc8f8f.svg";
export { ForwardRef as ReactComponent };